module.exports = __webpack_public_path__ + "img/anjoman_s.65e253a.png";